enum EntityTypes {
  product = 'Product',
  synthesisStep = 'SynthesisStep',
  campaign = 'Campaign',
  batch = 'Batch',
}

export default EntityTypes;
